module.exports = __webpack_public_path__ + "share-24.3b771485.svg";